module.exports = __webpack_public_path__ + "../resources/images/fileType_sprite-43e61986d7db66251db5ab0ea26724b0.png";